export { default as LanguageSwitcher } from './language-switcher'
